module.exports = __webpack_public_path__ + "img/user-id-pass.bf443ce0.svg";